import React, { type ComponentType, type PropsWithChildren } from 'react';
import { type JSONValue, type PluginCollection } from '@atlassiansox/cross-flow-base-types';
import { CrossFlowProvider } from './lib/CrossFlowProvider';
import { type AnalyticsWebClientInterface, type MaybePromise } from './lib/types';
export { useCrossFlow, withCrossFlow, Journeys, Targets, Reasons } from './index';
export type { WithCrossFlowProps, TargetType } from './index';

interface ConfluenceProps {
	analyticsClient: MaybePromise<AnalyticsWebClientInterface>;
	cloudId: string;
	globalExperimentalOptions?: Record<string, JSONValue>;
	locale: string;
	plugins?: PluginCollection;
}

const ConfluenceProvider: ComponentType<PropsWithChildren<ConfluenceProps>> = (props) => {
	return <CrossFlowProvider {...props} originProduct="confluence" />;
};

export default ConfluenceProvider;
